<script lang="ts">
  import type { Editor } from "@tiptap/core";
  import IconButton from "$components/+blocks/IconButton/IconButton.svelte";
  import { TableLeft, TableRight, Trash, TableUp, TableDown } from "$components/+blocks/OVIcon";

  export let editor: Editor;
  export let type: "row" | "column";
  export let updatePosition: () => void;
  export let element: HTMLDivElement;
</script>

<div
  class="z-[2] flex w-fit gap-1 rounded-md border border-gray-300 bg-white p-1 dark:border-white/10 dark:bg-gray-700 dark:text-gray-300"
  contenteditable="false"
  bind:this={element}
>
  {#if type === "column"}
    <!-- column menu options -->
    <IconButton
      a11yLabel="Add column left"
      on:click={() => {
        updatePosition();
        editor.commands.addColumnBefore();
      }}
      icon={TableLeft}
      variant="tertiary"
      size="small"
      customIconSize="w-5 h-5"
    />
    <IconButton
      a11yLabel="Add column right"
      on:click={() => {
        updatePosition();
        editor.commands.addColumnAfter();
      }}
      icon={TableRight}
      variant="tertiary"
      size="small"
      customIconSize="w-5 h-5"
    />
    <IconButton
      a11yLabel="Delete column"
      on:click={() => {
        updatePosition();
        editor.commands.deleteColumn();
      }}
      icon={Trash}
      variant="tertiary"
      size="small"
      customIconSize="w-4.5 h-4.5"
    />
  {:else}
    <!-- row menu options -->
    <IconButton
      a11yLabel="Add row above"
      on:click={() => {
        updatePosition();
        editor.commands.addRowBefore();
      }}
      icon={TableUp}
      variant="tertiary"
      size="small"
      customIconSize="w-5 h-5"
    />
    <IconButton
      a11yLabel="Add row below"
      on:click={() => {
        updatePosition();
        editor.commands.addRowAfter();
      }}
      icon={TableDown}
      variant="tertiary"
      size="small"
      customIconSize="w-5 h-5"
    />
    <IconButton
      a11yLabel="Delete row"
      on:click={() => {
        updatePosition();
        editor.commands.deleteRow();
      }}
      icon={Trash}
      variant="tertiary"
      size="small"
      customIconSize="w-4.5 h-4.5"
    />
  {/if}
</div>
